
import React from 'react';
import { Helmet } from 'react-helmet-async';

const AssistedReproductionSection = () => {
  const programs = [
    {
      title: "Con tus propios óvulos",
      description: "Te ofrecemos diversos programas con tus propios ovocitos:",
      features: [
        "Programa transfer por transfer",
        "Programa con nº de transfers y FIVs ilimitadas"
      ]
    },
    {
      title: "Con donante de óvulos",
      description: "Programas con donante de óvulos donde podrás seleccionar la donante:",
      features: [
        "Programa transfer por transfer",
        "Programa con nº de transfers y FIVs ilimitadas"
      ]
    },
    {
      title: "Con donante de semen",
      description: "Te facilitamos donante de semen, pudiendo escoger el candidato:",
      features: [
        "Programa transfer por transfer",
        "Programa con nº de transfers y FIVs ilimitadas"
      ]
    },
    {
      title: "Con embriones congelados",
      description: "Si tienes embriones en otra clínica, nos encargamos de su exportación legal para continuar el proceso en nuestras clínicas."
    },
       {
      title: "Selección de Sexo",
      description: "Programas donde podrás escoger el sexo del bebé si lo deseas.",
      highlight: false
    },
    {
      title: "Trasplante Pronuclear (Técnica de '3 Padres')",
      description: "Aplicamos trasplante pronuclear para madres que desean mantener el vínculo genético con su bebé.",
      highlight: false
    }
  ];

  const specialPrograms = [
    {
      title: "Programas Ilimitados con Garantía de Éxito",
      description: "Somos la única compañía que ofrece programas ilimitados con garantía de reembolso total o parcial en caso de no lograr el embarazo.",
      highlight: true
    }
    // {
    //   title: "Selección de Sexo",
    //   description: "Programas donde podrás escoger el sexo del bebé si lo deseas.",
    //   highlight: false
    // },
    // {
    //   title: "Trasplante Pronuclear (Técnica de '3 Padres')",
    //   description: "Aplicamos trasplante pronuclear para madres que desean mantener el vínculo genético con su bebé.",
    //   highlight: false
    // }
  ];

  const containerStyle = {
    backgroundColor: '#f9fafb',
    padding: '4rem 1rem',
    fontFamily: 'Arial, sans-serif'
  };

  const maxWidthStyle = {
    maxWidth: '1280px',
    margin: '0 auto'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '4rem'
  };

  const badgeStyle = {
    display: 'inline-block',
    padding: '0.5rem 1.5rem',
    background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
    color: 'white',
    borderRadius: '9999px',
    fontSize: '0.875rem',
    fontWeight: '600',
    marginBottom: '1rem'
  };

  const mainTitleStyle = {
    fontSize: 'clamp(2rem, 5vw, 3rem)',
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: '1rem',
    lineHeight: '1.2'
  };

  const gradientTextStyle = {
    background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  };

  const subtitleStyle = {
    fontSize: '1.25rem',
    color: '#6b7280',
    marginBottom: '2rem'
  };

  const sectionTitleStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#111827',
    marginBottom: '3rem'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
    marginBottom: '4rem'
  };

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    padding: '2rem',
    transition: 'box-shadow 0.3s ease'
  };

  const cardHeaderStyle = {
    marginBottom: '1.5rem'
  };

  const colorBlockStyle = {
     width: '1.5rem',
    height: '1.5rem',
    background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
    borderRadius: '50%',
    marginBottom: '1rem'
  };

  const cardTitleStyle = {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#111827'
  };

  const descriptionStyle = {
    color: '#6b7280',
    marginBottom: '1rem',
    lineHeight: '1.6'
  };

  const featureListStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0
  };

  const featureItemStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '0.5rem'
  };

  const bulletStyle = {
    width: '0.5rem',
    height: '0.5rem',
    backgroundColor: '#10b981',
    borderRadius: '50%',
    marginRight: '0.75rem',
    marginTop: '0.5rem',
    flexShrink: 0
  };

  const specialProgramsStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem'
  };

  const getSpecialCardStyle = (highlight) => ({
    borderRadius: '0.75rem',
    padding: '2rem',
    ...(highlight 
      ? {
          background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
          color: 'white'
        }
      : {
          backgroundColor: 'white',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
        }
    )
  });

  const specialCardContentStyle = {
    display: 'flex',
    alignItems: 'flex-start'
  };

  const getSpecialColorBlockStyle = (highlight) => ({
    width: '3rem',
    height: '3rem',
    borderRadius: '0.5rem',
    marginRight: '1.5rem',
    flexShrink: 0,
    ...(highlight 
      ? {
          backgroundColor: 'rgba(255, 255, 255, 0.2)'
        }
      : {
          background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)'
        }
    )
  });

  const getSpecialTitleStyle = (highlight) => ({
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: highlight ? 'white' : '#111827'
  });

  const getSpecialDescriptionStyle = (highlight) => ({
    fontSize: '1.125rem',
    lineHeight: '1.7',
    color: highlight ? 'white' : '#6b7280'
  });

  const ctaStyle = {
    textAlign: 'center',
    marginTop: '4rem'
  };

  const ctaCardStyle = {
    backgroundColor: 'white',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    padding: '2rem',
    maxWidth: '48rem',
    margin: '0 auto'
  };

  const ctaTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: '1rem'
  };

  const ctaDescriptionStyle = {
    color: '#6b7280',
    marginBottom: '1.5rem'
  };

  const buttonStyle = {
    background: 'linear-gradient(40deg, #EE6FBB, #7BADD3)',
    color: 'white',
    padding: '0.75rem 2rem',
    borderRadius: '9999px',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease'
  };

  return (
      <>
         <Helmet>
           <title>Numero 1 en reproduccion asistida - Gestlife</title>
           <meta name="description" content="Gestlife numero uno en reproduccion asistida en Europa" />
         </Helmet>
    <div style={containerStyle}>
      <div style={maxWidthStyle}>
        {/* Header Section */}
        <div style={headerStyle}>
          <div style={badgeStyle}>
            Nº 1 EN EUROPA
          </div>
          <h1 style={mainTitleStyle}>
            Nº 1 EN PROGRAMAS DE <br />
            <span style={gradientTextStyle}>
              REPRODUCCIÓN ASISTIDA
            </span>
          </h1>
          <p style={subtitleStyle}>
            La mayoría elige Gestlife
          </p>
        </div>

        {/* Main Programs Section */}
        <div>
          <h2 style={sectionTitleStyle}>
            PROGRAMAS DE REPRODUCCIÓN ASISTIDA A TU MEDIDA
          </h2>
          
          <div style={gridStyle}>
            {programs.map((program, index) => (
              <div key={index} style={cardStyle}>
                <div style={cardHeaderStyle}>
                  <div style={colorBlockStyle}></div>
                  <h3 style={cardTitleStyle}>{program.title}</h3>
                </div>
                
                <p style={descriptionStyle}>{program.description}</p>
                
                {program.features && (
                  <ul style={featureListStyle}>
                    {program.features.map((feature, featureIndex) => (
                      <li key={featureIndex} style={featureItemStyle}>
                        <div style={bulletStyle}></div>
                        <span style={{color: '#374151'}}>{feature}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Special Programs Section */}
        <div style={specialProgramsStyle}>
          {specialPrograms.map((program, index) => (
            <div 
              key={index} 
              style={getSpecialCardStyle(program.highlight)}
            >
              <div style={specialCardContentStyle}>
                <div style={getSpecialColorBlockStyle(program.highlight)}>
                </div>
                <div style={{flex: 1}}>
                  <h3 style={getSpecialTitleStyle(program.highlight)}>
                    {program.title}
                  </h3>
                  <p style={getSpecialDescriptionStyle(program.highlight)}>
                    {program.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action
        <div style={ctaStyle}>
          <div style={ctaCardStyle}>
            <h3 style={ctaTitleStyle}>
              ¿Listo para comenzar tu journey?
            </h3>
            <p style={ctaDescriptionStyle}>
              Contáctanos para más información sobre nuestros programas personalizados
            </p>
            <button 
              style={buttonStyle}
              onMouseEnter={(e) => {
                e.target.style.transform = 'scale(1.05)';
                e.target.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = 'none';
              }}
            >
              Contactar Ahora
            </button> */}
          {/* </div>
        </div> */}
      </div>
    </div>
    </>
  );
};

export default AssistedReproductionSection;